import getHelper from '../../../services/getHelper';
import TeamsHelper from './organizations/TeamsHelper';
import AnalyticsHelper from './AnalyticsHelper';
import InvitationsHelper from './InvitationsHelper';

import withBulkedInvitations from './withBulkedInvitations';
import { TalentsSavedSearch } from '../../talents-saved-searches/types';

const OrganizationsHelper = getHelper('/organizations/:id', {
  teams: TeamsHelper,
  analytics: AnalyticsHelper,
  users: getHelper('/users/:id', {
    roles: getHelper('/roles/:id'),
    talentsSavedSearches: getHelper<TalentsSavedSearch>('/talents-saved-searches/:id'),
  }),
  invitations: InvitationsHelper,
});

export default withBulkedInvitations(OrganizationsHelper);
